import React, { Component } from "react";
import { FaXmark } from "react-icons/fa6";
import "./FuterePast.css";
import zaglushka from "../img/zaglushka.jpg";

export class Past extends Component {
  state = {
    searchDraft: "",
    searchApplied: "",
  };

  handleInputChange = (e) => {
    const value = e.target.value;

    this.setState({
      searchDraft: value,
      searchApplied: value.trim() === "" ? "" : this.state.searchApplied,
    });
  };

  applySearch = () => {
    this.setState({
      searchApplied: this.state.searchDraft.trim().toLowerCase(),
    });
  };

  clearSearch = () => {
    this.setState({
      searchDraft: "",
      searchApplied: "",
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.applySearch();
  };

  render() {
    const q = this.state.searchApplied;

    const filteredItems = this.props.items
      .filter((el) => el.now === false && el.ready === true)
      .filter((el) => {
        if (!q) return true;
        return (
          el.title?.toLowerCase().includes(q) ||
          el.who?.toLowerCase().includes(q)
        );
      })
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return (
      <section className="Past">
        <h2 className="TextForHead">Отсмотрено</h2>

        <div className="pastControls">
          <div className="input-xmark">
            <input
              className="sort"
              placeholder="Название или заказчика"
              value={this.state.searchDraft}
              onChange={this.handleInputChange}
              onKeyDown={this.handleKeyDown}
            />
            {this.state.searchDraft && (
              <FaXmark className="Xmark" onClick={this.clearSearch} />
            )}
          </div>

          <button className="buttonScan" onClick={this.applySearch}>
            Поиск
          </button>
        </div>

        <div className="pastGrid">
          {filteredItems.length > 0 ? (
            filteredItems.map((el) => (
              <article className="card" key={el.id}>
                <div className="cardMedia">
                  <img
                    alt={el.title || "Постер"}
                    src={el.img_url}
                    loading="lazy"
                  />
                </div>

                <div className="cardBottom">
                  <h3 className="cardTitle">{el.title}</h3>
                  <p>Заказчик: {el.who}</p>
                  <p>Отсмотрено: {el.howMany}</p>
                  <p>Дата заказа: {el.when}</p>
                </div>
              </article>
            ))
          ) : q ? (
            <div className="empty-state">
              <div className="empty-text">
                По запросу «{this.state.searchApplied}» ничего не найдено
              </div>

              <div className="empty-image-wrapper">
                <img src={zaglushka} alt="Увы" className="empty-image" />
              </div>
            </div>
          ) : null}
        </div>
      </section>
    );
  }
}

export default Past;
